import Image from "next/image";
import { css } from "@emotion/react";
import { mq } from "@/constants/breakpoints";

interface ImageConfig {
  src: string;
  screenSize: keyof typeof mq;
  width: number;
  height: number;
}

interface ResponsiveNextImageProps {
  images: ImageConfig[];
  alt: string;
  priority?: boolean;
}

export function ResponsiveNextImage({
  images,
  alt,
  priority = false,
}: ResponsiveNextImageProps) {
  const sortedBreakpoints = ["xs", "sm", "md", "lg", "xl", "xl2", "xl3"];

  return (
    <div>
      {images.map((image) => {
        const currentIndex = sortedBreakpoints.indexOf(image.screenSize);
        const nextImageBreakpoint = images.find(
          (nextImage) =>
            sortedBreakpoints.indexOf(nextImage.screenSize) > currentIndex
        )?.screenSize;

        return (
          <Image
            key={`${image.src}-${image.screenSize}`}
            src={image.src}
            width={image.width}
            height={image.height}
            alt={alt}
            priority={priority}
            css={css`
              display: none;
              ${mq[image.screenSize]} {
                display: block;
              }
              ${nextImageBreakpoint && mq[nextImageBreakpoint]} {
                display: none;
              }
            `}
          />
        );
      })}
    </div>
  );
}
